import {routesWithHiddenForm} from "@Routing/constants/routesWithHiddenForm";

export const isRouteWithHiddenForm = () => {
    const searchParams = new URLSearchParams(window.location.search);

    return routesWithHiddenForm.includes(window?.currentRoute) || searchParams.get('no_header') === "1"
}